import { render, staticRenderFns } from "./ProjectMain.vue?vue&type=template&id=dc254d08&scoped=true&"
import script from "./ProjectMain.vue?vue&type=script&lang=js&"
export * from "./ProjectMain.vue?vue&type=script&lang=js&"
import style0 from "./ProjectMain.vue?vue&type=style&index=0&id=dc254d08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc254d08",
  null
  
)

export default component.exports